import { useNavigate } from 'react-router-dom';
import PrizeNavigation from "../components/PrizeNavigation";
import SpecialPrimaryButtons from "../components/SpecialPrimaryButtons";
import styles from "./AccountCreateSuccess.module.css";

function AccountCreateSuccess() {
  const navigate = useNavigate();
  
  const handleButtonClick = () => {
    navigate('../leaguenamesetup');
  };

  return (
    <div className={styles.accountCreateSuccess}>
      <PrizeNavigation navigationButtonArea="/2813821-1@2x.png" />
      <div className={styles.mainContent}>
        <p className={styles.primaryText}>Your account has been created!</p>
        <p className={styles.secondaryText}>Let's get started on setting up your league. Click on the button below to begin.</p>
        <SpecialPrimaryButtons
          label="Get started"
          onClick={handleButtonClick}
        />
      </div>
    </div>
  );
}
// test

export default AccountCreateSuccess;

